import { render, staticRenderFns } from "./TrademarkOppositionList.vue?vue&type=template&id=31d512a6&"
import script from "./TrademarkOppositionList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionList.vue?vue&type=style&index=0&id=31d512a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports